<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-2 sidebar-project bg-custom-blue py-3">

        <!-- Header left sidebar -->
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h4 class="mb-0">{{ $t("views.nav.manageSysParms") }}</h4>
        </div>

        <!-- Sidebar (Treeview mit SysParm-Kategorien) -->
        <div class="row mt-4">
          <div class="col-12">
            <ul class="treeview mt-2">
              <li @click="selectNode('general')" class="treeview-item">
                <div class="cont-icon-org-unit d-inline-block me-1">
                  <svg class="bi" width="16" height="16" fill="currentColor"> <use xlink:href="@/assets/icons/icons.svg#measure" /> </svg>
                  &nbsp; {{ $t("views.sysparms.treeview.catGeneral") }}
                </div>
              </li>
              <li @click="selectNode('strategies')" class="treeview-item">
                <div class="cont-icon-org-unit d-inline-block me-1">
                  <svg class="bi" width="16" height="16" fill="currentColor"> <use xlink:href="@/assets/icons/icons.svg#strategy" /> </svg>
                  &nbsp; {{ $t("views.sysparms.treeview.catStrategies") }}
                </div>
              </li>
              <li @click="selectNode('objectives')" class="treeview-item">
                <div class="cont-icon-org-unit d-inline-block me-1">
                  <svg class="bi" width="16" height="16" fill="currentColor"> <use xlink:href="@/assets/icons/icons.svg#objective" /> </svg>
                  &nbsp; {{ $t("views.sysparms.treeview.catObjectives") }}
                </div>
              </li>
              <li @click="selectNode('monitoring')" class="treeview-item">
                <div class="cont-icon-org-unit d-inline-block me-1">
                  <svg class="bi" width="16" height="16" fill="currentColor"> <use xlink:href="@/assets/icons/icons.svg#kpi" /> </svg>
                  &nbsp; {{ $t("views.sysparms.treeview.catMonitoring") }}
                </div>
              </li>
              <li @click="selectNode('projects')" class="treeview-item">
                <div class="cont-icon-org-unit d-inline-block me-1">
                  <svg class="bi" width="16" height="16" fill="currentColor"> <use xlink:href="@/assets/icons/icons.svg#project" /> </svg>
                  &nbsp; {{ $t("views.sysparms.treeview.catProjects") }}
                </div>
              </li>
              <li @click="selectNode('organisation')" class="treeview-item">
                <div class="cont-icon-org-unit d-inline-block me-1">
                  <svg class="bi" width="16" height="16" fill="currentColor"> <use xlink:href="@/assets/icons/icons.svg#orgunit" /> </svg>
                  &nbsp; {{ $t("views.sysparms.treeview.catOrganisation") }}
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Content  -->
      <div class="col-10 px-5 py-3">

        <!-- SysParms General -->
        <div v-if="selectedNodeTitle === 'general'">
          <div class="d-flex align-items-center mb-2">
            <h3 class="mb-0 me-2">{{ $t("views.sysparms.treeview.catGeneral")}}</h3>
          </div>
          <p>{{ $t("views.sysparms.treeview.catGeneralText") }}</p>
          <div class="text-center mt-5">
            <img src="@/assets/img/no_data.svg" class="img-fluid" width="250">
            <p class="h5 mt-3">{{ $t("views.sysparms.treeview.noParms") }}.</p>
          </div>
        </div>

        <!-- SysParms Strategies -->
        <div v-else-if="selectedNodeTitle === 'strategies'">

          <!-- Header -->
          <div class="d-flex align-items-center mb-2">
            <h3 class="mb-0">{{ $t("views.sysparms.treeview.catStrategies") }}</h3>
          </div>
          <p>{{ $t("views.sysparms.treeview.catStrategiesText") }}</p>

          <!-- Treeview -->
          <h5 class="mb-0">{{ $t("views.sysparms.strategy.subcatStrategyTree")}}</h5>
          <p>{{ $t("views.sysparms.strategy.subcatStrategyTreeText")}}</p>

          <div class="row">
            <div class="col-3">
              <label for="strategyTreeDefaultLevel" class="form-label">
                 {{ $t("views.sysparms.strategy.strategyTreeDefaultLevel")}}
              </label>
            </div>
            <div class="col-5">
              <select v-model="form.strategies.strategyTreeDefaultLevel.content" class="form-select form-select-sm" style="width: 60px;">
                <option v-for="n in [2,3,4,5,6,7,8]" :key="n" :value="n"> {{ n }} </option>
              </select>
            </div>
          </div>

        </div>

        <!-- SysParms Objectives -->
        <div v-else-if="selectedNodeTitle === 'objectives'">

          <!-- Header -->
          <div class="d-flex align-items-center mb-2">
            <h3 class="mb-0">{{ $t("views.sysparms.treeview.catObjectives") }}</h3>
          </div>
          <p>{{ $t("views.sysparms.treeview.catObjectivesText") }}</p>

          <!-- Treeview -->
          <h5 class="mb-0">{{ $t("views.sysparms.objective.subcatObjectiveTree")}}</h5>
          <p>{{ $t("views.sysparms.objective.subcatObjectiveTreeText")}}</p>

          <div class="row">
            <div class="col-3">
              <label for="objectiveTreeDefaultLevel" class="form-label">
                 {{ $t("views.sysparms.objective.objectiveTreeDefaultLevel")}}
              </label>
            </div>
            <div class="col-5">
              <select v-model="form.objectives.objectiveTreeDefaultLevel.content" class="form-select form-select-sm" style="width: 60px;">
                <option v-for="n in [2,3,4,5,6,7,8]" :key="n" :value="n"> {{ n }} </option>
              </select>
            </div>
          </div>

          <!-- Objective Model -->
          <h5 class="mb-0 mt-3">{{ $t("views.sysparms.objective.subcatObjectiveModel")}}</h5>
          <p>{{ $t("views.sysparms.objective.subcatObjectiveModelText")}}</p>

          <div class="row">
            <div class="col-3">
              <label for="objectiveModel" class="form-label">
                 {{ $t("views.sysparms.objective.objectiveModel")}}
              </label>
            </div>
            <div class="col-5">
              <select v-model="form.objectives.objectiveModel.content" class="form-select form-select-sm" style="width: 120px;">
                <option v-for="type in ['Hoshin', 'OKR', 'Hybrid']" :key="type" :value="type"> {{ type }} </option>
              </select>
            </div>
            <p class="alert alert-warning mt-3" role="alert">{{ $t("views.sysparms.objective.subcatObjectiveModelAlert")}}</p>
          </div>

        </div>

        <!-- SysParms Monitoring -->
        <div v-else-if="selectedNodeTitle === 'monitoring'">

          <!-- Header -->
            <div class="d-flex justify-content-between align-items-center mb-2">
              <h3 class="mb-0">{{ $t("views.sysparms.treeview.catMonitoring") }}</h3>
            </div>
            <p>{{ $t("views.sysparms.treeview.catMonitoringText") }}</p>

          <!-- Treeview -->
          <h5 class="mb-0">{{ $t("views.sysparms.monitoring.subcatKpiTree")}}</h5>
          <p>{{ $t("views.sysparms.monitoring.subcatKpiTreeText")}}</p>

          <div class="row">
            <div class="col-3">
              <label for="kpiTreeDefaultLevel" class="form-label">
                 {{ $t("views.sysparms.monitoring.kpiTreeDefaultLevel")}}
              </label>
            </div>
            <div class="col-5">
              <select v-model="form.monitoring.kpiTreeDefaultLevel.content" class="form-select form-select-sm" style="width: 60px;">
                <option v-for="n in [2,3,4,5,6,7,8]" :key="n" :value="n"> {{ n }} </option>
              </select>
            </div>
          </div>

          <!-- KPI Charts -->
          <h5 class="mb-0 mt-3">{{ $t("views.sysparms.monitoring.subcatKpiChart")}}</h5>
          <p>{{ $t("views.sysparms.monitoring.subcatKpiChartText")}}</p>

          <div class="row">
            <div class="col-3">
              <label for="kpiChartMonthPast" class="form-label">
                 {{ $t("views.sysparms.monitoring.kpiChartMonthPast")}}
              </label>
            </div>
            <div class="col-5">
                <input v-model="form.monitoring.kpiChartMonthPast.content" type="text" id="kpiChartMonthPast"  class="form-control form-control-sm" style="width: 60px;"  @blur="focusOut(form.monitoring.kpiChartMonthPast.content, 'monitoring', 'kpiChartMonthPast')" :class="form.monitoring.kpiChartMonthPast.error === '' ? ' form-control' : 'form-control is-invalid'">
                <div class="invalid-feedback">{{ form.monitoring.kpiChartMonthPast.error }}</div>
            </div>
          </div>

          <div class="row">
            <div class="col-3">
              <label for="kpiChartMonthFuture" class="form-label">
                {{ $t("views.sysparms.monitoring.kpiChartMonthFuture")}}
              </label>
            </div>
            <div class="col-5">
                <input v-model="form.monitoring.kpiChartMonthFuture.content" type="text" id="kpiChartMonthFuture"  class="form-control form-control-sm" style="width: 60px;"  @blur="focusOut(form.monitoring.kpiChartMonthFuture.content, 'monitoring', 'kpiChartMonthFuture')" :class="form.monitoring.kpiChartMonthFuture.error === '' ? ' form-control' : 'form-control is-invalid'">
                <div class="invalid-feedback">{{ form.monitoring.kpiChartMonthFuture.error }}</div>
            </div>
          </div>

          <div class="row">
            <div class="col-3">
              <label for="kpiChartMonthPast" class="form-label">
                {{ $t("views.sysparms.monitoring.kpiChartQuarterPast")}}
              </label>
            </div>
            <div class="col-5">
                <input v-model="form.monitoring.kpiChartQuarterPast.content" type="text" id="kpiChartQuarterPast"  class="form-control form-control-sm" style="width: 60px;"  @blur="focusOut(form.monitoring.kpiChartQuarterPast.content, 'monitoring', 'kpiChartQuarterPast')" :class="form.monitoring.kpiChartQuarterPast.error === '' ? ' form-control' : 'form-control is-invalid'">
                <div class="invalid-feedback">{{ form.monitoring.kpiChartQuarterPast.error }}</div>
            </div>
          </div>

          <div class="row">
            <div class="col-3">
              <label for="kpiChartQuarterFuture" class="form-label">
                {{ $t("views.sysparms.monitoring.kpiChartQuarterFuture")}}
              </label>
            </div>
            <div class="col-5">
                <input v-model="form.monitoring.kpiChartQuarterFuture.content" type="text" id="kpiChartQuarterFuture"  class="form-control form-control-sm" style="width: 60px;"  @blur="focusOut(form.monitoring.kpiChartQuarterFuture.content, 'monitoring', 'kpiChartQuarterFuture')" :class="form.monitoring.kpiChartQuarterFuture.error === '' ? ' form-control' : 'form-control is-invalid'">
                <div class="invalid-feedback">{{ form.monitoring.kpiChartQuarterFuture.error }}</div>
            </div>
          </div>

          <div class="row">
            <div class="col-3">
              <label for="kpiChartYearPast" class="form-label">
                {{ $t("views.sysparms.monitoring.kpiChartYearPast")}}
              </label>
            </div>
            <div class="col-5">
                <input v-model="form.monitoring.kpiChartYearPast.content" type="text" id="kpiChartYearPast"  class="form-control form-control-sm" style="width: 60px;"  @blur="focusOut(form.monitoring.kpiChartYearPast.content, 'monitoring', 'kpiChartYearPast')" :class="form.monitoring.kpiChartYearPast.error === '' ? ' form-control' : 'form-control is-invalid'">
                <div class="invalid-feedback">{{ form.monitoring.kpiChartYearPast.error }}</div>
            </div>
          </div>

          <div class="row">
            <div class="col-3">
              <label for="kpiChartYearFuture" class="form-label">
                {{ $t("views.sysparms.monitoring.kpiChartYearFuture")}}
              </label>
            </div>
            <div class="col-5">
                <input v-model="form.monitoring.kpiChartYearFuture.content" type="text" id="kpiChartYearFuture"  class="form-control form-control-sm" style="width: 60px;"  @blur="focusOut(form.monitoring.kpiChartYearFuture.content, 'monitoring', 'kpiChartYearFuture')" :class="form.monitoring.kpiChartYearFuture.error === '' ? ' form-control' : 'form-control is-invalid'">
                <div class="invalid-feedback">{{ form.monitoring.kpiChartYearFuture.error }}</div>
            </div>
          </div>
        </div>

        <!-- SysParms Projects -->
        <div v-else-if="selectedNodeTitle === 'projects'">

          <!-- Header -->
          <div class="d-flex align-items-center mb-2">
            <h3 class="mb-0">{{ $t("views.sysparms.treeview.catProjects") }}</h3>
          </div>
          <p>{{ $t("views.sysparms.treeview.catProjectsText") }}</p>

          <!-- Treeview -->
          <h5 class="mb-0">{{ $t("views.sysparms.project.subcatProjectTree")}}</h5>
          <p>{{ $t("views.sysparms.project.subcatProjectTreeText")}}</p>
          <div class="row">
            <div class="col-3">
              <label for="projectTreeDefaultLevel" class="form-label"> {{ $t("views.sysparms.project.projectTreeDefaultLevel")}} </label>
            </div>
            <div class="col-5">
              <select v-model="form.projects.projectTreeDefaultLevel.content" class="form-select form-select-sm" style="width: 60px;">
                <option v-for="n in [2,3,4,5,6,7,8]" :key="n" :value="n"> {{ n }} </option>
              </select>
            </div>
          </div>

        </div>

        <!-- SysParms Organisation -->
        <div v-else-if="selectedNodeTitle === 'organisation'">

          <!-- Header -->
          <div class="d-flex align-items-center mb-2">
            <h3 class="mb-0">{{ $t("views.sysparms.treeview.catOrganisation") }}</h3>
          </div>
          <p>{{ $t("views.sysparms.treeview.catOrganisationText") }}</p>

          <!-- Treeview -->
          <h5 class="mb-0">{{ $t("views.sysparms.org.subcatOrgTree")}}</h5>
          <p>{{ $t("views.sysparms.org.subcatOrgTreeText")}}</p>

          <div class="row">
            <div class="col-3">
              <label for="orgTreeDefaultLevel" class="form-label">
                 {{ $t("views.sysparms.org.orgTreeDefaultLevel")}}
              </label>
            </div>
            <div class="col-5">
              <select v-model="form.organisation.orgTreeDefaultLevel.content" class="form-select form-select-sm" style="width: 60px;">
                <option v-for="n in [2,3,4,5,6,7,8]" :key="n" :value="n"> {{ n }} </option>
              </select>
            </div>
          </div>

        </div>

        <!-- Save / Close  -->
        <div v-if="selectedNodeTitle !== ''">
          <div class="d-flex justify-content-end bg-light p-2">
            <button type="button" class="btn btn-sm btn-outline-secondary me-2" @click="selectedNodeTitle = ''"> {{ $t("general.close") }} </button>
            <button type="button" class="btn btn-sm btn-primary" @click="save()"> {{ $t("general.save") }} </button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import * as formatUtils from '@/composables/formatUtils'
import * as validation from '@/composables/validation'

export default {
  name: 'ManageSysParm',
  data () {
    return {
      selectedNodeTitle: '',
      form: {
        strategies: {
          strategyTreeDefaultLevel: {
            content: '',
            error: '',
            validate: []
          }
        },
        objectives: {
          objectiveTreeDefaultLevel: {
            content: '',
            error: '',
            validate: []
          },
          objectiveModel: {
            content: '',
            error: '',
            validate: []
          }
        },
        monitoring: {
          kpiTreeDefaultLevel: {
            content: '',
            error: '',
            validate: []
          },
          kpiChartMonthPast: {
            content: '',
            error: '',
            maxLength: 2,
            validate: ['empty', 'length']
          },
          kpiChartMonthFuture: {
            content: '',
            error: '',
            maxLength: 2,
            validate: ['empty', 'length']
          },
          kpiChartQuarterPast: {
            content: '',
            error: '',
            maxLength: 2,
            validate: ['empty', 'length']
          },
          kpiChartQuarterFuture: {
            content: '',
            error: '',
            maxLength: 2,
            validate: ['empty', 'length']
          },
          kpiChartYearPast: {
            content: '',
            error: '',
            maxLength: 2,
            validate: ['empty', 'length']
          },
          kpiChartYearFuture: {
            content: '',
            error: '',
            maxLength: 2,
            validate: ['empty', 'length']
          }
        },
        projects: {
          projectTreeDefaultLevel: {
            content: '',
            error: '',
            validate: []
          }
        },
        organisation: {
          orgTreeDefaultLevel: {
            content: '',
            error: '',
            validate: []
          }
        }
      }
    }
  },
  computed: {
    sysParms () {
      return this.$store.state.sysParms
    }
  },
  methods: {
    selectNode (title) {
      this.selectedNodeTitle = title
      // Anpassung erforderlich !!
      this.elementType = title

      Object.entries(this.sysParms).forEach(([key, value]) => {
        try {
          this.form[this.elementType][key].content = value
        } catch (e) { }
      })
    },
    focusOut: function (number, category, field) {
      const formattedNumber = this.formatInputNumber(number)
      this.form[category][field].content = formattedNumber
    },
    async save () {
      let valid = 0
      valid = validation.fieldValidation(this.form[this.elementType])

      if (valid === 0) {
        const elementData = Object.assign(
          ...Object.entries(this.form[this.elementType]).map(([key, value]) => ({ [key]: value.content }))
        )
        this.$store.commit('SET_LOADING_STATUS', true)
        await this.$store.dispatch('setSysParms', elementData)
        this.$store.commit('SET_LOADING_STATUS', false)
      }
    },
    formatInputNumber (number) {
      const userLocale = this.$store.state.user.settings?.language
      const decimals = 0
      return formatUtils.formatInputNumber(userLocale, number, decimals)
    }
  },
  async created () {
    this.$store.commit('SET_LOADING_STATUS', true)
    await this.$store.dispatch('getSysParms')
    this.$store.commit('SET_LOADING_STATUS', false)
  }
}
</script>

<style lang="scss" scoped>
.progress-label {
  transform: translate(-50%, -50%);
}

.tab-content .progress {
  margin-top: 6px;
}

.treeview {
  list-style-type: none;
  padding-left: 0;
}

.treeview li {
  list-style: none;        // Keine Bullet points
  font-size: 1.1rem;       // Größere Schrift
  line-height: 1.8rem;     // Mehr Abstand zwischen den Zeilen
  margin-bottom: 0.4rem;   // Optional: zusätzlicher Abstand zwischen Einträgen
  cursor: pointer;
}

.treeview-item:hover {
  font-weight: bold
}

.treeview-item.selected {
  font-weight: bold;
}

</style>
